import React, { useState } from "react";
import { format } from "date-fns";
import { useFormikContext } from "formik";
import DatePickerField from "components/lib/Shared/DatePickerField";

const ManageAppointmentDate = ({
  field,
  form,
  designation,
  registrationDate,
}) => {
  const { setFieldValue } = useFormikContext();
  const [startDate, setStartDate] = useState("");

  const minAppointmentDate = new Date(registrationDate);

  const handleDateValue = (date) => {
    if (!date) {
      setFieldValue(field.name, "");
      return;
    }
    if (isNaN(date.getTime())) {
      console.error("Invalid date:", date);
      return;
    }

    // Format the valid date
    const formattedDate = format(date, "yyyy/MM/dd");
    setFieldValue(field.name, formattedDate);
  };

  return (
    <div className="col-span-6 sm:col-span-3">
      <DatePickerField
        label={`Date of Becoming ${designation}`}
        form={form}
        onChange={handleDateValue}
        selected={field.value ? new Date(field.value) : null}
        minDate={minAppointmentDate}
        name="appointmentDate"
        placeholderText="Enter dates of becoming"
        errorPath="identificationDetails.appointmentDate"
        disabled={false}
      />
    </div>
  );
};

export default ManageAppointmentDate;
